import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  speakText,
  formatSpeechMessage,
  initializeVoices
} from '../../../helpers/textToSpeech';

const useSpeakOnItemChange = (item) => {
  const prevItemRef = useRef(null);
  const isInitializedRef = useRef(false);
  const lastSpeakTimeRef = useRef(0);

  const voicePackingEnabled = useSelector(
    state => state.user?.settings?.data?.voice_packing
  );

  useEffect(() => {
    initializeVoices();
  }, []);

  const speakItemLocation = async (itemToSpeak, isItemChange = true) => {
    try {
      const now = Date.now();
      if (now - lastSpeakTimeRef.current < 1500) {
        return;
      }

      if (!itemToSpeak) {
        return;
      }

      const message = await formatSpeechMessage(itemToSpeak, null, isItemChange);

      if (message) {
        lastSpeakTimeRef.current = now;
        await speakText(message);
      }
    } catch (error) {
      console.error('Error in speakItemLocation:', error);
    }
  };

  const hasItemChanged = (prevItem, currentItem) => {
    if (!prevItem && !currentItem) return false;
    if (!prevItem || !currentItem) return true;

    return (
      prevItem.product_id !== currentItem.product_id ||
      prevItem.order_item_id !== currentItem.order_item_id ||
      prevItem.sku !== currentItem.sku
    );
  };

  useEffect(() => {
    if (!voicePackingEnabled) {
      prevItemRef.current = item;
      return;
    }

    const prevItem = prevItemRef.current;
    const itemChanged = hasItemChanged(prevItem, item);

    if (item && itemChanged) {
      if (!isInitializedRef.current) {
        isInitializedRef.current = true;
        const mountTimer = setTimeout(() => {
          speakItemLocation(item, true);
        }, 500);

        prevItemRef.current = item;
        return () => clearTimeout(mountTimer);
      }

      speakItemLocation(item, true);
    }

    prevItemRef.current = item;
  }, [item, voicePackingEnabled]);

  return {
    speakItemLocation,
    voicePackingEnabled
  };
};

export default useSpeakOnItemChange;

